import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './AdminLogin.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/admin/login', {
        email,
        password
      });

      localStorage.setItem('adminToken', response.data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      setLoading(false);
      setError('Invalid email or password');
    }
  };

  return (
    <div className="admin-login">
      {loading && (
        <div className="admin-login-overlay" role="status" aria-live="polite" aria-busy="true">
          <div className="admin-login-overlay-card">
            <div className="admin-login-spinner" aria-hidden="true" />
            <p className="admin-login-overlay-text">Signing in…</p>
            <p className="admin-login-overlay-hint">Please wait while we verify your credentials.</p>
          </div>
        </div>
      )}
      <div className="admin-login-container">
        <h2>Admin Login</h2>
        <p className="admin-login-sub">Sign in with your credentials</p>
        <form onSubmit={handleSubmit} aria-busy={loading}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Signing in…' : 'Login'}
          </button>
        </form>
        <a
          href="/"
          className={`admin-login-back-link${loading ? ' admin-login-back-link--disabled' : ''}`}
          tabIndex={loading ? -1 : 0}
          aria-disabled={loading}
        >
          ← Back to Home
        </a>
      </div>
    </div>
  );
}

export default AdminLogin;
